import allDepositTransactions from './prebuiltReports/allDepositTransactions';
import allStockPositions from './prebuiltReports/allStockPositions';
import allAssetsByROI from './prebuiltReports/allAssetsByROI';
import allAssetsSunburst from './prebuiltReports/allAssetsSunburst';
import transactionsByMonthBarStacked from './prebuiltReports/transactionsByMonthBarStacked';
import assetBalanceChanges from './prebuiltReports/assetsBalanceChanges';
import inflowsByType from './prebuiltReports/inflowsByType';
import assetsByMonthStacked from './prebuiltReports/snapshotsByMonthBarStacked';
import snapshotsByYearBar from './prebuiltReports/snapshotsByYearBar';
import kpiReport from './prebuiltReports/kpiReport';
import kpiReportUnisel from './prebuiltReports/kpiReportUnisel';
import quotesByYearLine from './prebuiltReports/quoteByYearLine';

const prebuiltReportDefs = [
  allDepositTransactions,
  allStockPositions,
  allAssetsByROI,
  allAssetsSunburst,
  transactionsByMonthBarStacked,
  assetBalanceChanges,
  inflowsByType,
  assetsByMonthStacked,
  snapshotsByYearBar,
  kpiReport,
  kpiReportUnisel,
  quotesByYearLine,
];

export default prebuiltReportDefs;
